import React from 'react';
import { useIsMobile } from '../../hooks';
import { Icon } from '../Icon';

import './styles.scss';

interface Props {
    title?: string;
    onBackClick?: () => void;
    backLinkText?: string;
    hideBackLink?: boolean;
}

export const Header = ({ title, onBackClick, backLinkText, hideBackLink }: Props) => {
    const isMobile = useIsMobile();

    const backClickHandler = () => {
        if (onBackClick) {
            onBackClick();
        }
    };

    return (
        <div className='app-page-header'>
            <div
                className={`razem-app__wrapper app-page-header__wrapper ${
                    backLinkText ? 'app-page-header__wrapper--position-regular' : ''
                }`}
            >
                {isMobile && !hideBackLink && onBackClick && (
                    <button
                        onClick={backClickHandler}
                        className={`app-page-header__back-button ${
                            backLinkText ? 'app-page-header__back-button--position-regular' : ''
                        }`}
                    >
                        <Icon icon='chevron-left' color='white' size='20' />
                        {backLinkText ? <span className='app-page-header__backlink-text'>{backLinkText}</span> : ''}
                    </button>
                )}
                {title && <h3 className='app-page-header__title'>{title}</h3>}
            </div>
        </div>
    );
};
